<template>
  <!-- 设备管理-->
 <div class="cont">
    <div class="map" >
      <div id="map"></div>
      <div class="detail" >
        <div class="searchBox" ref="searchBox">
          <el-form :inline="true"  ref=""  class="demo-form-inline jiaoyan" label-width="80px" size="mini">
            <div class="inpbox">
              <span>起点</span>
              <input id='startId' ref="tipinput" type="text" autocomplete="off">
            </div>
            <div class="inpbox">
              <span>终点</span>
              <input id='endId' ref="tipinput" type="text" autocomplete="off">
            </div>
            <div class="inpbox">
              <span>车牌号</span>
             <input id='' ref="tipinput" v-model="vehNo" type="text" autocomplete="off" >
            </div>
          <!-- <el-form-item label="起点:" >
              <input id='startId' ref="tipinput" type="text" autocomplete="off">
          </el-form-item>
          <el-form-item label="终点:" >
              <input id='endId' ref="tipinput" type="text" autocomplete="off">
          </el-form-item>
           <el-form-item label="车牌号:" >
              <input id='tipinput' ref="tipinput" v-model="vehNo" type="text" autocomplete="off" >
          </el-form-item> -->
         <div style="text-align: center;margin-bottom:10px">
           <!-- <button @click="searchFn">路径规划</button> -->
           <a href="javascript:void(0)" class="dir_submit" @click="searchFn">路径规划</a>
            <!-- <el-button type="primary" @click="searchFn">路径规划</el-button> -->
         </div>
        </el-form>
        </div>
        <div id="panel"></div>
      </div>
    </div>
 </div>
</template>

<script>
import AMap from 'AMap'
import { } from '@/api/vehMonitor'
export default {
  data () {
    return {
      vehNo: '',
      map: null,
      pathArr: [],
      auto: null,
      auto1: null,
      driving: null
    }
  },
  created () {

  },
  mounted () {
    this.initMap()
    AMap.plugin('AMap.TruckDriving', function () { })
  },
  methods: {
    searchFn () {
      if (this.pathArr[0] && this.pathArr[1]) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        var drivingOption = {
          policy: 1,
          size: 4,
          province: this.vehNo.substring(0, 1),
          number: this.vehNo.substring(1),
          panel: 'panel',
          map: this.map
        }
        if (this.driving) {
          this.driving.clear()
        }
        let that = this
        that.map.clearMap()
        this.driving = new AMap.TruckDriving(drivingOption) // 构造驾车导航类
        let arr = []
        if (this.pathArr[0].lnglat == null || this.pathArr[1].lnglat == null) {
          arr[0] = { keyword: this.pathArr[0].keyword }
          arr[1] = { keyword: this.pathArr[1].keyword }
        } else {
          arr[0] = { lnglat: this.pathArr[0].lnglat }
          arr[1] = { lnglat: this.pathArr[1].lnglat }
        }
        console.log(arr[0], arr[1])
        // 根据起终点坐标规划驾车路线
        this.driving.search(arr, function (status, result) {
          loading.close()
          if (status === 'complete' && result.info === 'OK') {
            result.routes.forEach(item => {
              that.drawRoute(item)
            })
          } else {
            that.$alert('获取驾车数据失败', '系统提示')
          }
        })
      } else {

      }
    },
    clearFn () {
      this.map.clearMap()
      this.searchFrom = { time: null }
      this.gpsInfos = []
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
      let that = this
      this.auto = new AMap.Autocomplete({
        input: 'startId'
      })
      AMap.event.addListener(this.auto, 'select', select)// 注册监听，当选中某条记录时会触发console.log(e)
      this.auto1 = new AMap.Autocomplete({
        input: 'endId'
      })
      AMap.event.addListener(this.auto1, 'select', select1)
      function select (e) {
        // placeSearch.setCity(e.poi.adcode)
        // placeSearch.search(e.poi.name)
        if (e.poi.location == '') {
          that.pathArr[0] = { lnglat: null, keyword: e.poi.name }
        } else {
          that.pathArr[0] = { lnglat: [e.poi.location.lng, e.poi.location.lat], keyword: e.poi.name }
        }
      }
      function select1 (e) {
        if (e.poi.location == '') {
          that.pathArr[1] = { lnglat: null, keyword: e.poi.name }
        } else {
          that.pathArr[1] = { lnglat: [e.poi.location.lng, e.poi.location.lat], keyword: e.poi.name }
        }
      }
    },
    resetForm () {
      this.searchFrom = { time: null }
    },
    drawRoute (route) {
      var path = parseRouteToPath(route)
      var routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: '#ffeeee',
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: '#0091ff',
        lineJoin: 'round'
      })
      routeLine.setMap(this.map)
      // 调整视野达到最佳显示区域
      this.map.setFitView()
      function parseRouteToPath (route) {
        var path = []

        for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i]

          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j])
          }
        }

        return path
      }
    }

  }
}
</script>
<style scoped lang='less'>
.cont{
  height:100%
}
.map{
  width: 100%;
  margin-top: -12px;
  height:100%;
  position: relative;
  background: #ddd;
}
.bottom{
  height: 30%;
}
#map{
  width: 100%;
  height: 100%;
}
.searchBox{
    background: #3d93fd;
    padding:16px;
}
.detail{
  position: absolute;
  left: 0px;
  top: 10px;
  background: #fff;
  max-height: 100%;
  overflow: auto;
  max-width: 316px;
  padding-bottom: 0;
  font-size: 12px;
  input{
    font-size: 12px;
    border: none;
    width: 210px;
    padding-left: 80px;
    height: 34px;
    line-height: 32px;
    border: none;
    background: transparent;
    text-indent: 5px;
    color: #acd7ff;
    padding: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    outline: none;
  }
}
.inpbox{
  position: relative;
  width: 260px;
  margin: 10px;
  color: #e1f1ff;
    background-color: #3587eb;
    text-align: right;
  span{
    font-size: 14px;
    color: #e1f1ff;
    position: absolute;
    left: 6px;
    line-height: 34px;
  }
}
.dir_submit{
    display: inline-block;
    padding: 0 25px;
    height: 32px;
    line-height: 32px;
    background-color: #559ffb;
    border: none;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    text-decoration: none;
    margin: 10px;
}
/deep/ .el-date-editor--datetimerange.el-input__inner{
      width: 340px;
}

</style>
